import { render, staticRenderFns } from "./TableByBets.vue?vue&type=template&id=2a241162&scoped=true"
import script from "./TableByBets.vue?vue&type=script&lang=js"
export * from "./TableByBets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a241162",
  null
  
)

export default component.exports